import { useCallback, useRef, useState } from 'react';
import styled from 'styled-components';
import { Icon } from '../Icon';
import { TypesIcon } from '../../types/TypesIcon';
import { colors } from '../../constants/Colors';
import { units } from '../../helpers/styles/units';
import { typography } from '../../helpers/styles/typography';
import { useOutSideClick } from '../../hooks/useOutSideClick';

const StyledWrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

const StyledTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
`;

const StyledMenu = styled.ul`
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 10;
  margin: ${units(2)} 0 0;
  padding: ${units(2)} 0;
  min-width: ${units(120)};
  list-style: none;
  background-color: ${colors.white};
  border: 1px solid ${colors.grayscale05};
  border-radius: ${units(4)};
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
`;

const StyledMenuItem = styled.li<{ $danger?: boolean }>`
  padding: ${units(3)} ${units(7)};
  cursor: pointer;
  color: ${({ $danger }) => ($danger ? colors.red : colors.grayscale80)};
  white-space: nowrap;

  ${typography(5)};

  &:hover {
    background: ${colors.primaryLight};
  }
`;

type Props = {
    onEdit: () => void;
    onDelete: () => void;
};

export const FaqActionsMenu = ({ onEdit, onDelete }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    const close = useCallback(() => setIsOpen(false), []);

    const handleOutSideClick = useCallback((event: Event) => {
        if (!ref.current?.contains(event.target as Node)) {
            close();
        }
    }, [close]);

    useOutSideClick(ref, handleOutSideClick);

    const handleEdit = () => {
        close();
        onEdit();
    };

    const handleDelete = () => {
        close();
        onDelete();
    };

    return (
        <StyledWrapper ref={ref}>
            <StyledTrigger type="button" onClick={() => setIsOpen(prev => !prev)} aria-label="Действия">
                <Icon type={TypesIcon.DOTS} width="24px" height="24px" viewBox="0 0 24 24" />
            </StyledTrigger>
            {isOpen && (
                <StyledMenu>
                    <StyledMenuItem onClick={handleEdit}>Редактировать</StyledMenuItem>
                    <StyledMenuItem $danger onClick={handleDelete}>Удалить</StyledMenuItem>
                </StyledMenu>
            )}
        </StyledWrapper>
    );
};
